import { steps } from "../../../mocks/bizlab";
import { useScrollAnimation } from "../../../hooks/useScrollAnimation";

export default function HowItWorksSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="how-it-works" className="py-24 bg-white" ref={ref}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="text-xs font-bold uppercase tracking-widest text-blue-400 mb-3 block">
            Simple Process
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            How BizLab Works
          </h2>
          <p className="text-slate-500 text-base max-w-lg mx-auto">
            Four simple steps to transform your workplace operations — from request to insight.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connector line (desktop) */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-0.5 bg-slate-100 z-0" />

          {steps.map((step, index) => (
            <div
              key={step.id}
              className={`relative z-10 flex flex-col items-center text-center transition-all duration-700 ${
                isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
              }`}
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              {/* Number badge */}
              <div className="w-20 h-20 rounded-full bg-blue-400 flex flex-col items-center justify-center mb-5 shadow-md relative">
                <span className="text-white text-xs font-bold opacity-60 leading-none">{step.number}</span>
                <div className="w-8 h-8 flex items-center justify-center mt-0.5">
                  <i className={`${step.icon} text-white text-xl`} />
                </div>
              </div>

              <h3 className="text-base font-semibold text-slate-900 mb-2">{step.title}</h3>
              <p className="text-sm text-slate-500 leading-relaxed max-w-[220px]">
                {step.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA below */}
        <div
          className={`text-center mt-14 transition-all duration-700 delay-500 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <button
            onClick={() => {
              const el = document.querySelector("#contact");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-2 px-7 py-3 bg-slate-900 hover:bg-slate-700 text-white text-sm font-semibold rounded-full transition-all duration-200 hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            Get Started Today
            <i className="ri-arrow-right-line" />
          </button>
        </div>
      </div>
    </section>
  );
}
